module.exports = __webpack_public_path__ + "img/pumpcharge light.0f537fe9.png";